import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import OrgDocumentationPageContent from '@shared/components/organization/settings/OrgDocumentationPageContent';
import { useCurrentOrgNavigation } from '@shared/hooks/useCurrentOrgNavigation';
import { useTranslation } from 'react-i18next';

// TODO ADMIN PANEL: Update to allow editing of custom resources
export default function OrgDocumentationPage() {
    useCurrentOrgNavigation();
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <>
            <PageHeader title={t('common:resources.title')} items={items}>
                {/* {currentOrg.isAdmin && <Button $color="secondary" href={`#/org/${currentOrg?.organizationId}/settings`}>
                    {t('common:edit')}
                </Button>} */}
            </PageHeader>
            <OrgDocumentationPageContent />
        </>
    );
}
